<template>
    <h2>{{ title }}</h2>
    {{ string }}<br>
    {{ integer }}<br>
    {{ boolean }}<br>
    {{ test }}<br>
</template>

<script>
export default {
    name: 'CustomElementOne',
    data() {
        return {
            title: 'Custom Element 1'
        }
    },
    props: {
        string: String,
        integer: Number,
        boolean: Boolean,
        test: Object
    },
    mounted() {
        // console.log(this.string, this.integer, this.boolean, this.test);
    }
}
</script>

<style>
@import '/vue-components/ce-poc/dist/css/app.css';
</style>